var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect3, _path16, _path17, _path18, _path19, _rect4, _path20, _path21, _path22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencilPleat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    enableBackground: "new 0 0 80 80",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: -0.1,
    fill: "none",
    stroke: "#A9A9A9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 80,
    height: 80.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.7,
    y: 9.2,
    fill: "#D2D2D2",
    width: 60.3,
    height: 15.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M10.9,26.2L10.9,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1h0.1c0.6,0,1,0.5,1,1v15.4C11.9,25.8,11.4,26.2,10.9,26.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M15,26.2L15,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1H15c0.6,0,1,0.5,1,1v15.4C16,25.8,15.6,26.2,15,26.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M19.2,26.2L19.2,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1h0.1c0.6,0,1,0.5,1,1v15.4C20.2,25.8,19.7,26.2,19.2,26.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M23.3,26.2L23.3,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1h0.1c0.6,0,1,0.5,1,1v15.4C24.4,25.8,23.9,26.2,23.3,26.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M27.5,26.2L27.5,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1h0.1c0.6,0,1,0.5,1,1v15.4C28.5,25.8,28.1,26.2,27.5,26.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M31.7,26.2L31.7,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1h0.1c0.6,0,1,0.5,1,1v15.4C32.7,25.8,32.2,26.2,31.7,26.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M35.8,26.2L35.8,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1h0.1c0.6,0,1,0.5,1,1v15.4C36.8,25.8,36.4,26.2,35.8,26.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M40,26.2L40,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1H40c0.6,0,1,0.5,1,1v15.4C41,25.8,40.5,26.2,40,26.2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M44.1,26.2L44.1,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1h0.1c0.6,0,1,0.5,1,1v15.4C45.1,25.8,44.7,26.2,44.1,26.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M48.3,26.2L48.3,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1h0.1c0.6,0,1,0.5,1,1v15.4C49.3,25.8,48.8,26.2,48.3,26.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M52.4,26.2L52.4,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1h0.1c0.6,0,1,0.5,1,1v15.4C53.4,25.8,53,26.2,52.4,26.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M56.6,26.2L56.6,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1h0.1c0.6,0,1,0.5,1,1v15.4C57.6,25.8,57.1,26.2,56.6,26.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M60.7,26.2L60.7,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1h0.1c0.6,0,1,0.5,1,1v15.4C61.7,25.8,61.3,26.2,60.7,26.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M64.9,26.2L64.9,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1h0.1c0.6,0,1,0.5,1,1v15.4C65.9,25.8,65.4,26.2,64.9,26.2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.7132,
    strokeMiterlimit: 10,
    d: "M69,26.2L69,26.2c-0.6,0-1.1-0.5-1.1-1V9.8 c0-0.6,0.5-1,1-1H69c0.6,0,1,0.5,1,1v15.4C70.1,25.8,69.6,26.2,69,26.2z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9.4,
    y: 22.8,
    fill: "#D2D2D2",
    width: 60.9,
    height: 46.9
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.6529,
    strokeMiterlimit: 10,
    d: "M22.3,62.9c-0.3,0.9-1.9-10-0.5-19.7 c0.9-6.3,0.4-20.6,0.4-20.6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.6529,
    strokeMiterlimit: 10,
    d: "M47.7,66.6c-0.3,0.9,1.2-7.8,0.1-16.8 c-0.9-7.4-0.6-27.3-0.6-27.3"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.6529,
    strokeMiterlimit: 10,
    d: "M57.6,59.9c-0.3,0.9,0.5-4.2-0.6-16.7 c-0.6-6.4,0.4-20.6,0.4-20.6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.6529,
    strokeMiterlimit: 10,
    d: "M30.6,65.8c-0.3,0.9,1.3-5.8,0.6-15.7 c-0.5-7.4-0.6-27.3-0.6-27.3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.4,
    y: 8.3,
    fill: "#FFFFFF",
    width: 61.2,
    height: 2.7
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.6529,
    strokeMiterlimit: 10,
    d: "M14,22.6c0,0,1.6,16.3,0.6,23.3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.6529,
    strokeMiterlimit: 10,
    d: "M38.9,49.4c0,0,1.4-15.7-0.1-26.6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#717070",
    strokeWidth: 0.6529,
    strokeMiterlimit: 10,
    d: "M65.9,22.6c0,0,1.6,16.3,0.6,23.3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilPleat);
export default __webpack_public_path__ + "static/media/pencilPleat.4bd346865fb5584180f1a62f2138e62f.svg";
export { ForwardRef as ReactComponent };